import { journeyElementsStore } from '../JourneyElementsStore';
import { stringIsEmpty } from 'Util/TypeGuards';

export const getStopById = (stopId: string) => {
	return journeyElementsStore.getState().stops.find(x => x.id === stopId);
};

export const getStopByIdIfAny = (stopId?: string) => {
	if (stringIsEmpty(stopId)) {
		return undefined;
	}
	return getStopById(stopId);
};
